module.exports = __webpack_public_path__ + "static/Zendesk-6224038b985b5c5856a4abf1c55cc907.png";